// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_k1-0";
export var buttonContainer = "_k1-3";
export var cancelButton = "_k1-4";
export var headerSection = "_k1-6";
export var headerTitle = "_k1-9";
export var messageSideLeft = "_k1-1";
export var messageSideRight = "_k1-2";
export var orderNumberContainer = "_k1-7";
export var orderNumberLabel = "_k1-8";
export var submitButton = "_k1-5";